import { TenantTheme } from '../tenants/unbrace';

const sidebarTheme = (theme: TenantTheme) => ({
  animation: {
    entered: 'opacity: 1; transition: all 110ms ease; transform: none',
    entering: 'opacity: 0.01; transform: translateX(-20px)',
  },
  background: {
    active: theme.palette.primary.shade2,
    activeHighlight: theme.palette.primary.shade4,
    brand: theme.palette.neutral.shade1,
    hover: theme.palette.neutral.shade2,
    main: theme.palette.neutral.shade0,
    subMenuParent: theme.palette.neutral.shade2,
    submenu: theme.palette.neutral.shade1,
  },
  border: `2px solid ${theme.palette.neutral.shade2}`,
  color: {
    activeText: theme.palette.primary.shade7,
    filterLabel: theme.palette.neutral.shade5,
    filterTitle: theme.palette.neutral.shade9,
    icon: theme.palette.neutral.shade6,
    text: theme.palette.neutral.shade7,
  },
  mobile: {
    animation: {
      entered: 'opacity: 1; transition: all 110ms ease; transform: none',
      entering: 'opacity: 0.01; transform: translateY(20px)',
    },
    height: '79px',
    heightSmall: '66px',
    transition: 'left 0.2s cubic-bezier(0.67, 0.49, 0.15, 0.82)',
    width: '85%',
  },
  padding: {
    filter: '20px',
  },
  width: {
    huge: '320px',
    large: '260px',
    regular: '230px',
    small: '85px',
  },
});

export default sidebarTheme;
